export const AUTHORS = {
  isabella: {
    id: 'isabella',
    name: 'Isabella Marchetti',
    role: 'Editor-in-Chief',
    bio: 'Isabella has spent fifteen years documenting the world\'s most extraordinary weddings across six continents. Former editor at Condé Nast.',
    avatar: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=120&q=80',
  },
  celeste: {
    id: 'celeste',
    name: 'Celeste Fontaine',
    role: 'Beauty & Fashion Director',
    bio: 'Celeste Fontaine is a Paris-based beauty and fashion editor with fifteen years writing for European luxury titles. She covers skincare, fragrance, bridal fashion, and the beauty rituals that sit between all three.',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=120&q=80',
  },
  james: {
    id: 'james',
    name: 'James Hartley',
    role: 'Travel & Honeymoon Editor',
    bio: 'James has visited over 80 countries in pursuit of the world\'s finest honeymoon destinations. Based in London.',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=120&q=80',
  },
  sofia: {
    id: 'sofia',
    name: 'Sofia Esposito',
    role: 'Fashion & Beauty Editor',
    bio: 'Sofia covers bridal fashion, beauty, and style across Europe\'s leading ateliers and fashion weeks.',
    avatar: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?auto=format&fit=crop&w=120&q=80',
  },
  oliver: {
    id: 'oliver',
    name: 'Oliver Whitmore',
    role: 'Contributing Editor',
    bio: 'Oliver specialises in real wedding features and the stories behind the most memorable celebrations.',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=120&q=80',
  },
  taiwo: {
    id: 'taiwo',
    name: 'Taiwo Adedayo',
    role: 'Editor-in-Chief',
    bio: 'Taiwo Adedayo is the founder and Editor-in-Chief of Luxury Wedding Directory. With a decade of experience covering the world\'s most extraordinary celebrations, he leads the editorial vision of LWD, defining what luxury means for the modern couple.',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=120&q=80',
  },
};
